export default {
    EMessage: {
      'NO_RESULTS': { 'code': 0, 'message': 'No results found' },
      'COMPANY_NO_RESULTS': { 'code': 0, 'message': 'Parking lot or company not found' },
      'OK': { 'code': 1, 'message': 'The request was successfully processed' },
      'SYNCRONIZED_SUCCESSFUL': { 'code': 1, 'message': 'Successfully synchronized' },
      'FILE_UPLOADED_SUCCESS': { 'code': 2, 'message': 'The file has been successfully uploaded' },
      'ERROR_GENERAL': { 'code': -1, 'message': 'Error processing the request' },
      'ERROR_COMMIT': { 'code': -1500, 'message': 'Error confirming the data' },
      'ERROR_TOKEN_REQUIRED': { 'code': -1501, 'message': 'Token is required' },
      'ERROR_VALUES': { 'code': -507, 'message': 'You must specify the values' },
      'ERROR_VALUES_NOT_FOUND': { 'code': -511, 'message': 'Value not found' },
      'ERROR_ACCESS_REQUIRED': { 'code': -1502, 'message': 'You must enter the person\'s basic information' },
      'ERROR_EMAIL_REQUIRED': { 'code': -1503, 'message': 'Email is required' },
      'ERROR_SECRET_REQUIRED': { 'code': -1504, 'message': 'Password is required' },
      'ERROR_ENTITY_IDENTIFICATION_TYPE_REQUIRED': { 'code': -1505, 'message': 'Identification type is required' },
      'ERROR_ENTITY_NAME': { 'code': -1506, 'message': 'Name is required' },
      'ERROR_LOGIN': { 'code': -1507, 'message': 'Invalid username and/or password' },
      'ERROR_ACCOUNT_EXIST': { 'code': -1508, 'message': 'Email already exists' },
      'ERROR_COMPANY_NAME': { 'code': -1509, 'message': 'Company or parking lot name is required' },
      'ERROR_COMPANY_ADDRESS': { 'code': -1510, 'message': 'Company or parking lot address is required' },
      'ERROR_COMPANY_CLASSIFICATION': { 'code': -1511, 'message': 'Company or parking lot classification is required' },
      'ERROR_COMPANY_FATHER': { 'code': -1512, 'message': 'You must select the parent company' },
      'ERROR_COMPANY_LATITUDE': { 'code': -1513, 'message': 'Parking lot latitude is required' },
      'ERROR_COMPANY_LONGITUDE': { 'code': -1514, 'message': 'Longitude is required' },
      'ERROR_COMPANY_ALTITUDE': { 'code': -1515, 'message': 'Altitude is required' },
      'ERROR_COMPANY_TELEPHONE': { 'code': -1516, 'message': 'Company phone number is required' },
      'ERROR_COMPANY': { 'code': -1517, 'message': 'Company, parking lot, or regional information is required' },
      'ERROR_COMPANY_IDENTIFICATION': { 'code': -1518, 'message': 'Company identification is required' },
      'ERROR_COMPANY_TYPE_IDENTIFICATION': { 'code': -1519, 'message': 'Identification type is required' },
      'ERROR_COMPANY_EMAIL': { 'code': -1520, 'message': 'At least one email must be provided' },
      'ERROR_COMPANY_SELECT': { 'code': -1521, 'message': 'A company must be selected' },
      'ERROR_VEHICLE_INFO': { 'code': -1522, 'message': 'Vehicle information is required' },
      'ERROR_VEHICLE_PLATE': { 'code': -1523, 'message': 'Vehicle license plate or ID is required' },
      'ERROR_VEHICLE_OWNER': { 'code': -1524, 'message': 'Vehicle owner is required' },
      'ERROR_VEHICLE_CLASSIFICATION': { 'code': -1525, 'message': 'Vehicle type is required (Motorcycle, Car, Bicycle)' },
      'ERROR_PROFILE_REQUIRED': { 'code': -1526, 'message': 'Profile information is required' },
      'ERROR_PROFILE_TITLE': { 'code': -1527, 'message': 'Profile title is required' },
      'ERROR_PROFILE_ENTITY': { 'code': -1528, 'message': 'Company or person information is required' },
      'ERROR_ENTITY_IDENTIFICATION': { 'code': -1529, 'message': 'Company or person identification is required' },
      'ERROR_PROFILE_DELETE': { 'code': -1530, 'message': 'The profile could not be deleted' },
      'ERROR_PROFILE_CODE': { 'code': -1531, 'message': 'Profile identifier is required' },
      'ERROR_COMPANY_CODE': { 'code': -1532, 'message': 'Parking lot or company identifier is required' },
      'ERROR_PROPERTY_JSON': { 'code': -1533, 'message': 'JSON conversion could not be performed' },
      'ERROR_METHOD_FRANCHISE': { 'code': -1534, 'message': 'Franchise name must be provided' },
      'ERROR_METHOD_IDENTIFICATION': { 'code': -1535, 'message': 'Card number must be provided' },
      'ERROR_METHOD_EXPIRATION': { 'code': -1536, 'message': 'Card expiration date must be provided' },
      'ERROR_METHOD_NUMBER': { 'code': -1537, 'message': 'Verification number is required' },
      'ERROR_METHOD_FIND': { 'code': -1538, 'message': 'Payment method not found' },
      'ERROR_METHOD_CODE': { 'code': -1539, 'message': 'A payment method must be selected' },
      'ERROR_VEHICLE_NOT_FOUND': { 'code': -1540, 'message': 'Vehicle \'__COMPLEMENT__\' not found' },
      'ERROR_CALENDAR_INFO': { 'code': -1541, 'message': 'Calendar information must be provided' },
      'ERROR_CALENDAR_DAY': { 'code': -1542, 'message': 'A date must be selected' },
      'ERROR_CALENDAR_COMPANY': { 'code': -1543, 'message': 'A parking lot must be selected' },
      'ERROR_CALENDAR_CLASSIFICATION': { 'code': -1544, 'message': 'A classification for the day must be selected' },
      'ERROR_CALENDAR_ID': { 'code': -1545, 'message': 'An ID has not been received' },
      'ERROR_RESOLUTION_INITIAL_DATE': { 'code': -1546, 'message': 'Initial date must be selected' },
      'ERROR_RESOLUTION_FINAL_DATE': { 'code': -1547, 'message': 'Final date must be selected' },
      'ERROR_RESOLUTION_FINAL_VALUE': { 'code': -1548, 'message': 'Final number must be entered' },
      'ERROR_RESOLUTION_INITIAL_VALUE': { 'code': -1549, 'message': 'Initial number must be entered' },
      'ERROR_RESOLUTION_CURRENT_VALUE': { 'code': -1550, 'message': 'Current number must be entered' },
      'ERROR_RESOLUTION_VALUES': { 'code': -1551, 'message': 'Error in initial, final, and current values' },
      'ERROR_RESOLUTION': { 'code': -1552, 'message': 'Resolution information must be provided' },
      'ERROR_RESOLUTION_COMPANY': { 'code': -1553, 'message': 'A company must be selected' },
      'ERROR_RESOLUTION_DATE': { 'code': -1554, 'message': 'Initial date cannot be after final date' },
      'ERROR_RESOLUTION_ACTIVE': { 'code': -1555, 'message': 'There is an active resolution' },
      'ERROR_RESOLUTION_ID': {
        'code': -1556,
        'message': 'Resolution not found, please contact your administrator'
      },
      'ERROR_VOUCHER_TITLE': { 'code': -1557, 'message': 'Discount name is required' },
      'ERROR_VOUCHER': { 'code': -1558, 'message': 'Discount information is required' },
      'ERROR_VOUCHER_ID': { 'code': -1559, 'message': 'Discount code must be entered' },
      'ERROR_VOUCHER_CLASSIFICATION': { 'code': -1560, 'message': 'Discount classification is required' },
      'ERROR_VOUCHER_COMPANY': { 'code': -1561, 'message': 'A parking lot must be selected' },
      'ERROR_VOUCHER_NOT_FOUND': { 'code': -1562, 'message': 'Discount not found' },
      'ERROR_VOUCHER_EQUAL': { 'code': -1563, 'message': 'Discount code is already registered' },
      'ERROR_TARIFF_COMPANY': { 'code': -1564, 'message': 'A parking lot must be selected' },
      'ERROR_TARIFF_ID': {
        'code': -1565,
        'message': 'An identifier must be entered; it must be unique for the vehicle type and parking lot'
      },
      'ERROR_TARIFF_TITLE': { 'code': -1566, 'message': 'Tariff name must be entered' },
      'ERROR_TARIFF_LOST_TICKET': { 'code': -1567, 'message': 'Lost ticket value must be entered' },
      'ERROR_TARIFF_GRACE_TIME': { 'code': -1568, 'message': 'Grace period at exit must be entered' },
      'ERROR_TARIFF_SEGMENTS': { 'code': -1569, 'message': 'The tariff must have at least one segment' },
      'ERROR_TARIFF_SEGMENT_INITIAL_DAY': { 'code': -1570, 'message': 'Initial day of the segment must be selected' },
      'ERROR_TARIFF_SEGMENT_FINAL_DAY': { 'code': -1571, 'message': 'Final day of the segment must be selected' },
      'ERROR_TARIFF_SEGMENT_INITIAL_HOUR': {
        'code': -1572,
        'message': 'Initial hour of the segment must be selected'
      },
      'ERROR_TARIFF_SEGMENT_FINAL_HOUR': { 'code': -1573, 'message': 'Final hour of the segment must be selected' },
      'ERROR_TARIFF_SEGMENT_BLOCK_LIST': {
        'code': -1574,
        'message': 'All segments must have at least one block'
      },
      'ERROR_TARIFF_BLOCK_ID': { 'code': -1575, 'message': 'The block must have an identifier' },
      'ERROR_TARIFF_BLOCK_TIME': { 'code': -1576, 'message': 'Time must be specified in all blocks' },
      'ERROR_TARIFF_BLOCK_REPEAT': {
        'code': -1577,
        'message': 'You must specify how many times the block is repeated'
      },
      'ERROR_TARIFF_BLOCK_VALUE': { 'code': -1578, 'message': 'Block value is required' },
      'ERROR_TARIFF': { 'code': -1579, 'message': 'Tariff information is required' },
      'ERROR_DEVICE': { 'code': -1580, 'message': 'Device information is required' },
      'ERROR_SLOT': { 'code': -1581, 'message': 'Slot information must be provided' },
      'ERROR_SLOT_ID': {
        'code': -1582,
        'message': 'Slot ID is required and must be unique within the parking lot'
      },
      'ERROR_SLOT_TITLE': { 'code': -1583, 'message': 'Slot name must be entered' },
      'ERROR_SLOT_QUOTA': { 'code': -1584, 'message': 'Slot quota must be entered' },
      'ERROR_SLOT_FOUND': {
        'code': -1585,
        'message': 'A slot with the same code already exists in the parking lot'
      },
      'ERROR_SLOT_CODE': { 'code': -1586, 'message': 'A slot must be selected' },
      'ERROR_SLOT_NOT_FOUND': { 'code': -1587, 'message': 'Slot not found' },
      'ERROR_DEVICE_ID': { 'code': -1588, 'message': 'Device ID must be provided' },
      'ERROR_SCHEDULE_TITLE': { 'code': -1589, 'message': 'Schedule title must be entered' },
      'ERROR_SCHEDULE_DAYS': { 'code': -1590, 'message': 'Day information must be entered' },
      'ERROR_SCHEDULE': { 'code': -1591, 'message': 'Schedule information must be entered' },
      'ERROR_SCHEDULE_DAY_DAY': { 'code': -1592, 'message': 'Day must be selected' },
      'ERROR_SCHEDULE_DAY_INITIAL_HOUR': { 'code': -1593, 'message': 'Initial hour must be entered' },
      'ERROR_SCHEDULE_DAY_FINAL_HOUR': { 'code': -1594, 'message': 'Final hour must be entered' },
      'ERROR_SCHEDULE_COMPANY': { 'code': -1595, 'message': 'A parking lot must be selected' },
      'ERROR_SCHEDULE_ID': { 'code': -1596, 'message': 'A schedule must be selected' },
      'ERROR_SCHEDULE_NOT_FOUND': { 'code': -1597, 'message': 'Schedule to delete was not found' },
      'ERROR_SCHEDULE_MONTHLY': {
        'code': -1598,
        'message': 'The schedule has registered monthly users, therefore it cannot be deleted'
      },
      'ERROR_INCOME_SETTING_COMPANY': {
        'code': -1599,
        'message': 'A parking lot must be selected to proceed with the configuration'
      },
      'ERROR_PAY_CONFIG': {
        'code': -1600,
        'message': 'Error retrieving electronic payment configuration, please contact the administrator'
      },
      'ERROR_PAYU_BANKS': { 'code': -1601, 'message': 'Error retrieving banks from PAYU' },
      'ERROR_PAYU_METHODS': { 'code': -1602, 'message': 'Error retrieving payment methods' },
      'ERROR_PAYU_CREATE_TOKEN': { 'code': -1603, 'message': 'Error registering credit card' },
      'ERROR_PAY_CARD': { 'code': -1604, 'message': 'Card information not found' },
      'ERROR_PAYU_REMOVE_TOKEN': { 'code': -1605, 'message': 'Error deleting card in PAYU' },
      'ERROR_PAYU_PAY_SERVICE': { 'code': -1606, 'message': 'Error processing payment through the gateway' },
      'ERROR_INCOME_SPECIAL_COMPANY': {
        'code': -1607,
        'message': 'A company or parking lot must be selected'
      },
      'ERROR_INCOME_SPECIAL_ENTITY': {
        'code': -1608,
        'message': 'A person or third party must be selected'
      },
      'ERROR_INCOME_SPECIAL_QUOTA': {
        'code': -1609,
        'message': 'You must enter the number of vehicles the person can enter simultaneously'
      },
      'ERROR_INCOME_SPECIAL_SLOT': { 'code': -1610, 'message': 'You must select a slot' },
      'ERROR_INCOME_SPECIAL_SCHEDULE': { 'code': -1611, 'message': 'You must select a schedule' },
      'ERROR_INCOME_SPECIAL_LIQUIDATION': { 'code': -1612, 'message': 'You must select a liquidation' },
      'ERROR_INCOME_SPECIAL_VEHICLE': {
        'code': -1613,
        'message': 'You must add at least one vehicle'
      },
      'ERROR_INCOME_SPECIAL_VEHICLE_INFO': {
        'code': -1614,
        'message': 'Vehicle information must be provided'
      },
      'ERROR_INCOME_SETTING': { 'code': -1615, 'message': 'Record not found' },
      'ERROR_KIND': { 'code': -1616, 'message': 'You must send the type to query' },
      'ERROR_PAYU_QUERY_TRANSACTION': {
        'code': -1617,
        'message': 'Error retrieving the transaction'
      },
      'ERROR_PAY_QUERY_TRANSACTION': {
        'code': -1618,
        'message': 'Error retrieving the transaction'
      },
      'ERROR_COMPANY_LOCATION': {
        'code': -1619,
        'message': 'Error: the parking lot has no location'
      },
      'ERROR_COMPANY_NOT_FOUND_MAIN': {
        'code': -1620,
        'message': 'Error retrieving the main company of the parking lot'
      },
      'ERROR_STORE_TITLE': { 'code': -1621, 'message': 'Store name must be entered' },
      'ERROR_STORE_STREET_NUMBER': { 'code': -1622, 'message': 'Street number must be entered' },
      'ERROR_STORE_STREET_NAME': { 'code': -1623, 'message': 'Street name must be entered' },
      'ERROR_STORE_CODE': { 'code': -1624, 'message': 'A store must be selected' },
      'ERROR_STORE_NOT_FOUND': { 'code': -1625, 'message': 'Store not found' },
      'ERROR_STORE_MPID': {
        'code': -1626,
        'message': 'Payment Market identifier must be provided'
      },
      'ERROR_POS_TITLE': {
        'code': -1627,
        'message': 'Cash register name is required'
      },
      'ERROR_POS_EXTERNAL_ID': {
        'code': -1628,
        'message': 'You must enter the cash register identifier for Payment Market'
      },
      'ERROR_POS_CODE': { 'code': -1629, 'message': 'A cash register must be selected' },
      'ERROR_POS_MP_ID': {
        'code': -1630,
        'message': 'Payment Market identifier must be provided'
      },
      'ERROR_INVOICE_SUBTOTAL': { 'code': -1631, 'message': 'Subtotal is required' },
      'ERROR_INVOICE_TAX': { 'code': -1632, 'message': 'Tax value must be specified' },
      'ERROR_INVOICE_TOTAL': { 'code': -1633, 'message': 'Total value is required' },
      'ERROR_INVOICE_PREFIX': { 'code': -1634, 'message': 'Invoice prefix is required' },
      'ERROR_INVOICE_ENTITY': {
        'code': -1635,
        'message': 'Customer identification is required'
      },
      'ERROR_INVOICE_DETAILS': {
        'code': -1636,
        'message': 'Invoice details are required'
      },
      'ERROR_INVOICE_CONCEPT_INITIALS': {
        'code': -1637,
        'message': 'Concept initials are required'
      },
      'ERROR_INVOICE_CONCEPT_QUANTITY': {
        'code': -1638,
        'message': 'Detail quantity is required'
      },
      'ERROR_INVOICE_CONCEPT_UNIT_VALUE': {
        'code': -1639,
        'message': 'Unit value of the detail is required'
      },
      'ERROR_INVOICE_CONCEPT_TOTAL': {
        'code': -1640,
        'message': 'Total value of the detail is required'
      },
      'ERROR_CONCEPT_NOT_FOUND': {
        'code': -1641,
        'message': 'Concept not found with initials __COMPLEMENT__'
      },
      'ERROR_CONCEPT_NOT_FOUND_BY_TITLE': {
        'code': -1642,
        'message': 'Concept not found with name: __COMPLEMENT__'
      },
      'ERROR_INVOICE_NOT_FOUND': {
        'code': -1643,
        'message': 'Invoice not found "__COMPLEMENT__"'
      },
      'ERROR_PAYMENT_REQUEST': {
        'code': -1644,
        'message': 'Error while querying Payment Market'
      },
      'ERROR_TARIFF_CODE': {
        'code': -1645,
        'message': 'Error, no valid tariff code received'
      },
      'ERROR_INVOICE_INFO': {
        'code': -1646,
        'message': 'Invoice information is required'
      },
      'ERROR_NEXT_BLOCK': {
        'code': -1647,
        'message': 'Next value of the block is required'
      },
      'ERROR_TARIFF_BLOCK_NEXT': {
        'code': -1648,
        'message': 'The \'next\' value of one of the blocks is invalid'
      },
      'ERROR_TARIFF_BLOCK_CODE': {
        'code': -1649,
        'message': 'The code value of one of the blocks is duplicated'
      },
      'ERROR_CONCEPTS_CATEGORY_CONFIG': {
        'code': -1650,
        'message': 'The concepts category has not been configured'
      },
      'ERROR_CONCEPT_UPDATED': {
        'code': -1651,
        'message': 'Concept updated by another user, please fetch the latest changes'
      },
      'ERROR_LIQUIDATION_NO_EXIST': {
        'code': -1652,
        'message': 'Liquidation does not exist'
      },
      'ERROR_LIQUIDATION_CONCURRENCY': {
        'code': -1653,
        'message': 'Another user has updated the record'
      },
      'ERROR_IDENTIFICATION_REQUIRED': {
        'code': -1654,
        'message': 'Error, identification is required'
      },
      'ERROR_INCOME_SPECIAL_LIQUIDATION_NOT_FOUND': {
        'code': -1655,
        'message': 'No liquidation found for company __COMPLEMENT__'
      },
      'ERROR_SLOT_MAIN_COMPANY_NOT_FOUND': {
        'code': -1656,
        'message': 'No main slot exists for the company'
      },
      'ERROR_GRACE_OUT_TIME': {
        'code': -1657,
        'message': 'Error, grace period for exit is required'
      },
      'ERROR_FILE_IS_EMPTY': {
        'code': -1658,
        'message': 'Error, no file received'
      },
      'ERROR_SLOT_COMPANY_MAIN': {
        'code': -1659,
        'message': 'More than two slots are not allowed __COMPLEMENT__'
      },
      'ERROR_CATEGORY_LIQUIDATIONS': {
        'code': -1660,
        'message': 'No liquidation category exists'
      },
      'ERROR_SCHEDULE_MONTHLY_COMPANY': {
        'code': -1661,
        'message': 'The company __COMPLEMENT__ does not have an assigned schedule for monthly users'
      },
      'ERROR_MACHINE_COMPANY_NOT_FOUND': {
        'code': -1662,
        'message': 'The company __COMPLEMENT__ does not have a manual cash register device associated'
      },
      'ERROR_ENTITY_GENERIC': {
        'code': -1663,
        'message': 'Error retrieving default third-party, please create it as "__COMPLEMENT__" with id 111'
      },
      'ERROR_VEHICLE_PLATE_NO_FORMAT': {
        'code': -1664,
        'message': 'The vehicle\'s license plate format is invalid, record excluded'
      },
      'ERROR_CONCEPT_FIREBIRD': {
        'code': -1665,
        'message': 'Missing concepts for Firebird liquidation, please configure __COMPLEMENT__'
      },
      'ERROR_INVOICE_DETAIL_INSERT': {
        'code': -1666,
        'message': 'Error, concept not found for code "__COMPLEMENT__"'
      },
      'ERROR_INVOICE_PREFIX_BILL': {
        'code': -1667,
        'message': 'Error, please ensure there is a non-zero invoice number and a valid prefix'
      },
      'ERROR_INVOICE_DETAIL_CONCEPT': {
        'code': -1668,
        'message': 'Error, no valid option to continue the invoice detail process (invalid_concept)'
      },
      'ERROR_ENTITY': {
        'code': -1669,
        'message': 'Entity error'
      },
      'ERROR_ENTITY_NO_FOUND': {
        'code': -1670,
        'message': 'Error, user does not exist'
      },
      'ERROR_ENTITY_NO_FOUND_ACCESS': {
        'code': -1671,
        'message': 'Error, user does not have valid access, user __COMPLEMENT__ does not exist'
      },
      'ERROR_VEHICLE_MONTHLY': {
        'code': -1672,
        'message': 'Error, the vehicle __COMPLEMENT__ is registered in more than one monthly plan'
      },
      'ERROR_CARD_ID_REPLY': {
        'code': -1673,
        'message': 'Error, the company and parking code (cardId) is being used by another company'
      },
      'ERROR_TITLE_ACCOUNT': {
        'code': -1674,
        'message': 'Error, account title cannot be null'
      },
      'ERROR_USUCODIGO_REQUIRED': {
        'code': -1675,
        'message': 'Error, usucodigo is required'
      },
      'ERROR_PREFIX_REPLY': {
        'code': -1676,
        'message': 'Error, prefix has already been used'
      },
      'ERROR_USUCODIGO_REPLY': {
        'code': -1677,
        'message': 'Error, usucodigo has already been used'
      },
      'ERROR_SLOT_UNDEFINED': {
        'code': -1678,
        'message': 'Error, undefined slot'
      },
      'ERROR_SLOT_PRINCIPAL_REPLY': {
        'code': -1679,
        'message': 'Error, a main slot already exists in this company'
      },
      'ERROR_TARIFF_CODE_REPLY': {
        'code': -1680,
        'message': 'Error, a tariff with the entered code already exists'
      },
      'ERROR_DEVICE_NAME_REPLY': {
        'code': -1681,
        'message': 'Error, a device with this name already exists'
      },
      'ERROR_USER_ENTITY': {
        'code': -1682,
        'message': 'Error, user does not exist'
      },
      'ERROR_CONCEPT_TITLE_REPLY': {
        'code': -1683,
        'message': 'Error, a concept with the same name already exists'
      },
      'ERROR_LIQUIDATION_CONCEPT': {
        'code': -1684,
        'message': 'Error, liquidation concepts not found'
      },
      'ERROR_ENTITY_EXIST': {
        'code': -1685,
        'message': 'Email or identification already exists'
      },
      'ERROR_CATEGORY_NOT_FOUND': {
        'code': -1686,
        'message': 'Error finding category'
      },
      'ERROR_REPORT_DOWNLOAD': {
        'code': -1687,
        'message': 'Error generating report'
      },
      'ERROR_PARAMS_ACCESS_QUERY': {
        'code': -1688,
        'message': 'Error, you must provide an access code (code) or an entity code (entityCode)'
      },
      'ERROR_MOVEMENT_NOT_FOUND': {
        'code': -1689,
        'message': 'Error finding the movement "__COMPLEMENT__"'
      },
      'ERROR_DETAIL_NOT_FOUND': {
        'code': -1690,
        'message': 'Error finding invoice details'
      },
      'ERROR_DETAILS_NOT_FOUND': {
        'code': -1691,
        'message': 'Error finding invoice detail "__COMPLEMENT__"'
      },
      'OMIT_LIQUIDATION': {
        'code': -1692,
        'message': 'Error, liquidation "__COMPLEMENT__" is not valid'
      },
      'ERROR_LIQUIDATION_MOVEMENTS': {
        'code': -1693,
        'message': 'Error, the liquidation does not have an available movement'
      },
      'ERROR_LIQUIDATION_MULTIPLE_MOVEMENTS': {
        'code': -1694,
        'message': 'Error, the liquidation has more than one movement'
      },
      'ERROR_PAY_METHOD_NOT_FOUND': {
        'code': -1695,
        'message': 'Error, the payment method "__COMPLEMENT__" does not exist'
      },
      'ERROR_VEHICLE_TYPE_NOT_FOUND': {
        'code': -1696,
        'message': 'Error, the vehicle type "__COMPLEMENT__" does not exist'
      },
      'ERROR_DEVICE_ENTRY_NOT_FOUND': {
        'code': -1697,
        'message': 'Error, the entry device "__COMPLEMENT__" does not exist'
      },
      'ERROR_ROLLBACK_DATE_INVOICE': {
        'code': -1698,
        'message': 'Error, the invoice cancellation date is invalid __COMPLEMENT__'
      },
      'ERROR_DEVICE_TITLE': {
        'code': -1699,
        'message': 'Error, could not obtain the device name (IP) __COMPLEMENT__'
      },
      'ERROR_PERMISSIONS': {
        'code': -1700,
        'message': 'You do not have sufficient permissions to perform this operation'
      },
      'ERROR_VALUE_INCOMESPECIAL': {
        'code': -1701,
        'message': 'Error, the monthly value cannot be 0'
      },
      'ERROR_EMAIL_USED': {
        'code': -1702,
        'message': 'Error, the email is already registered'
      },
      'ERROR_EMAIL_EDIT': {
        'code': -1703,
        'message': 'You edited an already registered email'
      },
      'ERROR_TITLE_UNITY_USED': {
        'code': -1704,
        'message': 'This unit name has already been used'
      },
      'ERROR_CODE_UNITY_USED': {
        'code': -1705,
        'message': 'This unit name has already been used'
      },
      'ERROR_METHOD_PAY_PROPERTY_USED': {
        'code': -1706,
        'message': 'This payment method has already been configured'
      },
      'ERROR_IMEI': {
        'code': -1707,
        'message': 'Error, IMEI is required'
      },
      'ERROR_DEVICE_EXIST': {
        'code': -1708,
        'message': 'Error, device does not exist, please contact your administrator'
      },
      'ERROR_METHOD_NOT_SUPPORTED': {
        'code': -1709,
        'message': 'Error, HTTP method not supported'
      },
      'ERROR_VEHICLE_DETAIL_NOT_FOUND': {
        'code': -1710,
        'message': 'Vehicle "__COMPLEMENT__" not found'
      },
      'ERROR_METHOD_LOGIC': {
        'code': -1711,
        'message': 'The method has a logic error'
      },
      'ENUMERATION_NOT_FOUND': {
        'code': -1712,
        'message': 'Error, resolution not found'
      },
      'ERROR_INCOME_SPECIAL_NOT_FOUND': {
        'code': -1713,
        'message': 'Error, monthly plan not found'
      },
      'ERROR_INCOME_TYPE': {
        'code': -1714,
        'message': 'Error processing the subscription type'
      },
      'ERROR_ACCESS_NULL': {
        'code': -1715,
        'message': 'Error, access information is required'
      },
      'ERROR_INVOICE_INFO_ID': {
        'code': -1716,
        'message': 'Error, invoice ID does not exist'
      },
      'ERROR_INCOME_SPECIAL_ITEM': {
        'code': -1717,
        'message': 'You must add at least one item'
      },
      'ERROR_INCOME_SPECIAL_STATUS': {
        'code': -1718,
        'message': 'Subscriber status is required'
      },
      'ERROR_INCOME_SPECIAL_ITEM_FOUND': {
        'code': -1718,
        'message': 'The vehicle or item identifier is already in use: __COMPLEMENT__'
      },
      'ERROR_INCOME_ITEM': {
        'code': -1719,
        'message': 'There are duplicate card numbers for the same service, please validate the information'
      },
      'ERROR_INCOME_ITEM_NOT_FOUND': {
        'code': -1720,
        'message': 'Sorry, the item to be stored is not valid'
      },
      'ERROR_LOCKER_DETAIL_ID': {
        'code': -1719,
        'message': 'Error, no valid locker movement found'
      },
      'ERROR_LOCKER_DETAIL_NOT_FOUND': {
        'code': -1718,
        'message': 'Error, locker detail not found'
      },
      'ERROR_LIST_INCOME_ITEM': {
        'code': -1720,
        'message': 'Error, subscription item list is empty'
      },
      'ERROR_INCOME_SERVICE': {
        'code': -1721,
        'message': 'Error, subscriber service not obtained'
      },
      'ERROR_LOCKER_ID': {
        'code': -1722,
        'message': 'Error, locker code not found'
      },
      'ERROR_TOKEN_CORRUPT': {
        'code': -1723,
        'message': 'The token is malformed'
      },
      'ERROR_CARD': {
        'code': -1724,
        'message': 'Card number is required'
      },
      'ERROR_CONSECUTIVE': {
        'code': -1725,
        'message': 'Consecutive number is required'
      },
      'ERROR_VEHICLE_TYPE': {
        'code': -1726,
        'message': 'Vehicle type is required'
      },
      'ERROR_URL_REQUIRED': {
        'code': -1727,
        'message': 'Error, URL is required'
      },
      'ERROR_EMAIL_EXITS': {
        'code': -1728,
        'message': 'Error, email already exists'
      },
      'ERROR_DELETE_INCOME_ITEM': {
        'code': -1729,
        'message': 'Error deleting subscription item'
      },
      'ERROR_LIST_INCOME_SERVICE': {
        'code': -1730,
        'message': 'Error, subscription service list not found'
      },
      'ERROR_DEPOSIT_TOTAL': {
        'code': -1731,
        'message': 'Error, deposit total is required'
      },
      'ERROR_DEPOSIT_DATE': {
        'code': -1732,
        'message': 'Error, deposit date is required'
      },
      'ERROR_DEPOSIT_COMPANY': {
        'code': -1733,
        'message': 'Error, deposit company is required'
      },
      'ERROR_DEPOSIT_DETAIL_DEVICE': {
        'code': -1734,
        'message': 'Error, detail device is required'
      },
      'ERROR_TOTAL_DEPOSIT_DETAIL': {
        'code': -1735,
        'message': 'Error, detail total is required'
      },
      'ERROR_DEPOSIT': {
        'code': -1736,
        'message': 'Error, deposit detail is required'
      },
      'ERROR_FINANCE_DEVICE': {
        'code': -1737,
        'message': 'Error, financeReport device is required'
      },
      'ERROR_FINANCE_INITIAL_BILL': {
        'code': -1738,
        'message': 'Error, initial invoice is required for financeReport'
      },
      'ERROR_FINANCE_FINAL_BILL': {
        'code': -1739,
        'message': 'Error, final invoice is required for financeReport'
      },
      'ERROR_FINANCE_TOTAL_BILL': {
        'code': -1740,
        'message': 'Error, total issued invoices is required for financeReport'
      },
      'ERROR_FINANCE_COMPANY': {
        'code': -1741,
        'message': 'Error, company is required for financeReport'
      },
      'ERROR_FINANCE_INVOICED': {
        'code': -1742,
        'message': 'Error, total invoiced is required for financeReport'
      },
      'ERROR_FINANCE_ELECTRONIC_PAY': {
        'code': -1743,
        'message': 'Error, electronic payment is required for financeReport'
      },
      'ERROR_FINANCE_AMOUNT_COLLECTED': {
        'code': -1744,
        'message': 'Error, amount collected is required for financeReport'
      },
      'ERROR_FINANCE_DETAIL': {
        'code': -1745,
        'message': 'Error, deposit detail is required for financeReport'
      },
      'ERROR_FINANCE_EVENTS_REFUNDS': {
        'code': -1746,
        'message': 'Error, number of refunds is required for financeReport'
      },
      'ERROR_FINANCE_REFUNDS_VALUE': {
        'code': -1747,
        'message': 'Error, refund value is required for financeReport'
      },
      'ERROR_SAVE_SLOTDETAIL': {
        'code': -1748,
        'message': 'Error saving batch detail'
      },
      'ERROR_SPACE_NOT_AVAILABLE': {
        'code': -1749,
        'message': 'No space available for the selected criteria'
      },
      'ERROR_LOCATION_PREVIOUS': {
        'code': -1750,
        'message': 'Error finding previous space'
      },
      'ERROR_FINANCE_SUBTOTAL_INVOICED': {
        'code': -1751,
        'message': 'Error, subtotal invoiced is required for financeReport'
      },
      'ERROR_METHOD_NOT_FOUND_INVOICE': {
        'code': -1752,
        'message': 'No payments found for invoice __COMPLEMENT__'
      },
      'ERROR_MOVEMENT_CONSECUTIVE': {
        'code': -1753,
        'message': 'Error, the movement has no consecutive number'
      },
      'ERROR_MOVEMENT_ENTRY_DATE': {
        'code': -1754,
        'message': 'Error, the movement has no entry date'
      },
      'ERROR_SPACE_TO_FREE': {
        'code': -1755,
        'message': 'Error trying to free space'
      },
      'ERROR_FREQUENCY_TITLE': {
        'code': -1756,
        'message': 'Error, frequency title or name is required'
      },
      'ERROR_FREQUENCY_TIME': {
        'code': -1757,
        'message': 'Error, interval time is required in frequency'
      },
      'ERROR_FRECUENCY_INTERVAL': {
        'code': -1758,
        'message': 'Error, frequency interval is required'
      },
      'ERROR_SETTING_REPORT': {
        'code': -1759,
        'message': 'Error, sending configuration code is required'
      },
      'ERROR_FREQUENCY': {
        'code': -1760,
        'message': 'Error, sending frequency is required'
      },
      'ERROR_ADDRESSEE': {
        'code': -1761,
        'message': 'Error, sending recipient is required'
      },
      'ERROR_TYPE_REPORT': {
        'code': -1762,
        'message': 'Error, report format type is required for sending'
      },
      'ERROR_NEXT_RUN_DATE': {
        'code': -1763,
        'message': 'Error, next run date is required'
      },
      'ERROR_APP_SETTING': {
        'code': -1764,
        'message': 'Error, report app is required'
      },
      'ERROR_PARAMS_REQUIRED': {
        'code': -1765,
        'message': 'Error, report parameters are required'
      },
      'ERROR_API_SETTING': {
        'code': -1766,
        'message': 'Error, report API is required'
      },
      'ERROR_TOKEN': {
        'code': -1767,
        'message': 'Error, token information is required'
      },
      'ERROR_SHIPPING_DATE': {
        'code': -1768,
        'message': 'Error, sending date is required'
      },
      'ERROR_SEND_EMAIL': {
        'code': -1769,
        'message': 'Error, sending code is required'
      },
      'ERROR_SHIPPING_STATUS': {
        'code': -1770,
        'message': 'Error, sending status is required'
      },
      'ERROR_DESCRIPTION': {
        'code': -1771,
        'message': 'Error, sending description is required'
      },
      'ERROR_MOVEMENT': {
        'code': -1772,
        'message': 'Error, movement is required'
      },
      'ERROR_RECORD_ID': {
        'code': -1773,
        'message': 'Error, record ID is missing'
      },
      'ERROR_RECOD_TYPE': {
        'code': -1774,
        'message': 'Error, record type is missing'
      },
      'ERROR_ID_INVOICE': {
        'code': -1775,
        'message': 'Error, unique invoice ID is required'
      },
      'ERROR_ID_INVOICE_DETAIL': {
        'code': -1776,
        'message': 'Error, unique invoice detail ID is required'
      },
      'ERROR_ID_INVOICE_INFO': {
        'code': -1777,
        'message': 'Error, unique invoice info ID is required'
      },
      'ERROR_ID_PAYMENT': {
        'code': -1778,
        'message': 'Error, unique payment ID is required'
      },
      'ERROR_ID_PAYMENT_DETAIL': {
        'code': -1779,
        'message': 'Error, unique payment detail ID is required'
      },
      'ERROR_INTEGRATION_COMPANY': {
        'code': -1780,
        'message': 'Error, accounting software integration company is required'
      },
      'ERROR_INTEGRATION_TYPE': {
        'code': -1781,
        'message': 'Error, accounting integration type is required'
      },
      'ERROR_INTEGRATION_INFO': {
        'code': -1782,
        'message': 'Error, integration configuration is required'
      },
      'ERROR_INITIAL': {
        'code': -1783,
        'message': 'Error, unit initial is required'
      },
      'ERROR_DEVICES': {
        'code': -1784,
        'message': 'Error, device information is required'
      },
      'ERROR_DATE_REQUIRED': {
        'code': -1785,
        'message': 'Initial and/or final date must be selected'
      },
      'ERROR_INCORRECT_DATE_FORMAT': {
        'code': -1786,
        'message': 'Dates do not match the format yyyy-mm-dd'
      },
      'ERROR_RANGE_DATE': {
        'code': -1787,
        'message': 'Error, initial date cannot be later than final date'
      },
      'ERROR_RANGE_MAX_DAY': {
        'code': -1788,
        'message': 'Date range exceeds maximum allowed. Maximum days: __COMPLEMENT__'
      },
      'ERROR_FINAL_DATE': {
        'code': -1789,
        'message': 'Final date cannot be later than the current date'
      },
      'ERROR_CRITERIA_NOT_FOUND': {
        'code': -1790,
        'message': 'Search criteria must be selected'
      },
      'ERROR_INVOICE_LIST_CANCELED': {
        'code': -1791,
        'message': 'Error, there must be at least one invoice to cancel'
      },
      'ERROR_DESCRIPTION_CANCELED': {
        'code': -1792,
        'message': 'Error, a description must be added to cancel the invoice'
      },
      'ERROR_LOCKER_DETAIL_TYPE': {
        'code': -1793,
        'message': 'Error, no event type found for locker detail'
      },
      'ERROR_VOUCHER_DETAIL_INSTANT': {
        'code': -1794,
        'message': 'Error, discount usage date is required'
      },
      'ERROR_INCOME_ITEM_IDETIFICATION_DUPLICATE': {
        'code': -1795,
        'message': 'Sorry, the card number cannot be duplicated when the payment is individual. __COMPLEMENT__'
      },
      'ERROR_INCOME_SPECIAL': {
        'code': -1796,
        'message': 'Error, subscriber is required'
      },
      'ERROR_INCOME_SERVICE_TYPE': {
        'code': -1721,
        'message': 'Error, subscriber service must have a defined type'
      },
      'ERROR_INCOME_SERVICE_TYPE_DUPLICATE': {
        'code': -1721,
        'message': 'Error, the subscriber service type ESyncMessage is duplicated'
      },
      "ERROR_USED_PASSWORD": {
        "code": -2508,
        "message": "The password has already been used before, please enter a new one"
        }
    },
    ENotice: {
      //Test
      'PERSON_ERROR_AGE': 'The person\'s age is not valid.',
      'PERSON_ERROR_NAME': 'The person\'s name is required or invalid.',
      'PERSON_ERROR_NAME_SIZE': 'The person\'s name exceeds the allowed length.',
      'PERSON_ERROR_SURNAME': 'The person\'s surname is required or invalid.',
      'PERSON_NOT_FOUND': 'The person was not found.',
      //End-Test
  
      //ReportUtil
      'FORMAT_NOT_EXISTS': 'The requested format does not exist.',
      'FILE_NOT_FOUND': 'The file was not found.',
  
      //Global
      'GLOBAL_ERROR_COMPANY_REQUIRED': 'The company is required.',
      'GLOBAL_ERROR_DATE_FROM_REQUIRED': 'The start date is required.',
      'GLOBAL_ERROR_DATE_TO_REQUIRED': 'The end date is required.',
      //EndGlobal

      //Security
      'SECURITY_ERROR_ACCESS_INFO_NOT_FOUND': 'No se encontró la información del acceso',
      'SECURITY_ERROR_PASSWORD_REUSED': 'La contraseña ya ha sido utilizada antes, por favor ingresa una nueva',
      'GLOBAL_ERROR_CURRENT_PASSWORD_MISMATCH': 'La contraseña actual no coincide con la registrada',
  
      //BillingConcept
      'BILLING_CONCEPT_ERROR_QUERY_WAY': 'The query method is not valid for the billing concept.',
      'BILLING_CONCEPT_ERROR_CRITERIA': 'The search criteria are not valid for the billing concept.',
      'BILLING_CONCEPT_ERROR_QUERY_STATION': 'The query station is not valid for the billing concept.',
      'BILLING_CONCEPT_ERROR_SEARCH': 'An error occurred while searching for billing concepts.',
      'BILLING_CONCEPT_ERROR_SUMMARY': 'The billing concept summary could not be generated.',
      'BILLING_CONCEPT_NOT_FOUND': 'No billing concepts were found.',
      'BILLING_CONCEPT_CREATE_REPORT': 'The billing concept report could not be generated.',
      'BILLING_CONCEPT_ID_REQUIRED': 'The billing concept ID is required.',
      'BILLING_CONCEPT_SAVE': 'The billing concept was saved successfully.',
      'MOVEMENT_ERROR_NOT_FOUND': 'The movement was not found.',
  
      //IncomeMovement
      'INCOME_MOVEMENT_ID_REQUIRED': 'The income movement ID is required.',
      'INCOME_MOVEMENT_ERROR_CRITERIA': 'The search criteria for income movements are not valid.',
      'INCOME_MOVEMENT_ERROR_SEARCH': 'An error occurred while searching for income movements.',
      'INCOME_MOVEMENT_ERROR_SUMMARY': 'The income movement summary could not be generated.',
      'INCOME_MOVEMENT_NOT_FOUND': 'No income movements were found.',
      'INCOME_MOVEMENT_CREATE_REPORT': 'The income movement report could not be generated.',
      'INCOME_MOVEMENT_TARIFF_QUERY': 'Error when querying the income movement tariff.',
      //EndBillingConcept
  
      //Note
      "NOTE_ERROR_QUERY_ID": "The note ID for the query is invalid or was not provided.",
      //EndNote
  
      //NoteDetail
      "NOTE_DETAIL_ERROR_QUERY_NOTE": "The related note was not found or is invalid.",
      //EndNoteDetail
  
      //DetailedCollection
      "DETAILED_COLLECTION_ERROR_CRITERIA": "The criteria for the detailed collection are not valid.",
      "DETAILED_COLLECTION_ERROR_SEARCH": "An error occurred while searching the detailed collection.",
      "DETAILED_COLLECTION_NOT_FOUND": "No results were found in the detailed collection.",
      "DETAILED_COLLECTION_CREATE_REPORT": "The detailed collection report could not be generated.",
      //End DetailedCollection
  
      //Access
      "ACCESS_BY_COMPANY_NOT_FOUND": "Access for the selected company was not found.",
      // EndAccess
  
      //Online-discounts
      "MODULE_ACCESS_NOT_FOUND": "Access to the requested module was not found.",
      "DISCOUNTS_BY_LIQUIDATION_NOT_FOUND": "No discounts were found associated with the liquidation.",
      "ERROR_ACCESS_OWNER_REQUIRED": "The access owner is required.",
      "ERROR_LIQUIDATION_TYPE_REQUIRED": "The liquidation type is required.",
      "ERROR_VOUCHER_REQUIRED": "The voucher is required.",
      "ERROR_RECORD_ID_REQUIRED": "The record ID is required.",
      "ERROR_RECORD_TYPE_REQUIRED": "The record type is required.",
      //EndOnline-discounts
  
      //Movements
      "LAST_MOVEMENTS_NOT_FOUND": "The latest movements were not found.",
      "ERROR_PLATE_OR_CONSECUTIVE_REQUIRED": "You must provide the plate or the consecutive number to perform the search.",
      "ERROR_SEARCH_DATE_REQUIRED": "The search date is required.",
      "MOVEMENTS_BY_PLATE_OR_CONSECUTIVE_NOT_FOUND": "No movements were found for the entered plate or consecutive number.",
      "MODULE_ACCESS_TOKEN_NOT_FOUND": "The module access token was not found.",
      "ERROR_TITLE_MODULE_ACCESS_REQUIRED": "The module access title is required.",
      "ERROR_SEARCH_ALL_MOVEMENTS": "An error occurred while querying all movements.",
      "MOVEMENT_ERROR_PLATE_MIN_REQUIRED": "At least one valid plate number must be entered.",
      //EndMovements
  
      //CompanyForm
      "COMPANY_ERROR_SAVE": "An error occurred while saving the company information.",
      "COMPANY_FORM_ERROR_QUERY_ID": "The company could not be queried by ID.",
      "COMPANY_FORM_ERROR_QUERY_ALL": "The complete list of companies could not be retrieved.",
      "COMPANY_FORM_ERROR_QUERY_CUSTOM": "The custom query for companies could not be performed.",
      //EndCompanyForm
  
      //CompanySetting
      "COMPANY_SETTING_ERROR_SAVE": "An error occurred while saving the company settings.",
      "COMPANY_SETTING_ERROR_QUERY_FIND_TITLE_COMPANY": "The company could not be found by title.",
      "COMPANY_SETTING_ERROR_QUERY_FIND_COMPANY": "The specified company could not be found.",
      "COMPANY_SETTING_ERROR_COMPANY_REQUIRED": "The company is required for this operation.",
      //EndCompanySetting
  
      //Tariff
      "TARIFF_ERROR_FIND_ID": "The tariff with the provided ID was not found.",
      //EndTariff
  
      //InvoiceInfo
      "INVOICE_INFO_ERROR_FIND_ID_AND_TITLE": "The invoice information was not found by ID and title.",
      //EndInvoiceInfo
  
      //Invoice
      "INVOICE_ERROR_FIND_BY_PARAMETERS": "No invoices were found with the provided parameters.",
      "INVOICE_ERROR_PARAMETERS_NULL": "The invoice search parameters cannot be empty.",
      "INVOICE_ERROR_SYNC": "An error occurred during invoice synchronization.",
      "INVOICE_ERROR_SYNC_YESTERDAY": "Error synchronizing invoices from the previous day.",
      "INVOICE_ERROR_MISSING_DETAILS": "Necessary invoice details are missing.",
      "INVOICE_ERROR_QUERY_FAILED": "Error performing the invoice query.",
      "INVOICE_ERROR_QUERY_BY_CODE_FAILED": "The invoice could not be queried by code.",
      "INVOICE_ERROR_QUERY_INFORMATION": "The invoice information could not be retrieved.",
      "INVOICE_ERROR_DELETE_FAILED": "The invoice could not be deleted.",
      "INVOICE_ERROR_QUERY_TENANT_PAYMENT_FAILED": "The tenant payment could not be retrieved.",
      "INVOICE_ERROR_QUERY_PAYMENT_INVOICE_FAILED": "The payment associated with the invoice could not be retrieved.",
      //EndInvoice
  
      //InvoiceDetail
      "INVOICE_DETAIL_ERROR_FIND_CODE": "The invoice detail could not be found by code.",
      //EndInvoiceDetail
  
      //MethodSetting
      "METHOD_SETTING_NOT_FOUND": "The payment method setting was not found.",
      "METHOD_SETTING_ERROR_SAVE": "An error occurred while saving the payment method setting.",
      "METHOD_SETTING_ERROR_QUERY_PAYMENT_GATEWAY": "The configured payment gateway could not be retrieved.",
      //EndMethodSetting
  
      //Gopass
      "GOPASS_ERROR_NOT_FOUND_TERMINAL": "The terminal associated with GoPass was not found.",
      "GOPASS_ERROR_LIQUIDATION": "An error occurred with the GoPass liquidation.",
      "GOPASS_ERROR_DENIED": "Access to GoPass was denied.",
      //EndGopass
          //IncomeServiceConfig
      "INCOME_SERVICE_CONFIG_ERROR_SAVE": "The income service configuration could not be saved.",
      "INCOME_SERVICE_CONFIG_ERROR_FIND_LIST": "The list of income service configurations could not be retrieved.",
      //EndIncomeServiceConfig
  
      //Income item
      "ERROR_INCOME_ITEM_LIST_BY_PLATE": "The list of income items by plate could not be retrieved.",
      "ERROR_INCOME_SERVICE_CONFIG_FIND_BY_INCOME_SERVICE": "The income service configuration was not found.",
  
      //VoucherDetail
      "VOUCHER_DETAIL_ERROR_FIND_UUID_CLASSIFICATION": "The voucher classification by UUID could not be found.",
      //EndVoucherDetail
  
      //PaymentMethods
      "METHOD_PROPERTY_ERROR_ID_REQUIRED": "The payment method ID is required.",
      "ERROR_METHOD_REQUIRED": "The payment method is required.",
      "ERROR_SAVE_METHOD_SETTING": "The payment method configuration could not be saved.",
      "ERROR_FIND_METHOD_SETTING": "The payment method configuration could not be found.",
      "METHOD_PROPERTY_ERROR_FIND_BY_METHOD_SETTING": "The payment method property could not be found from its configuration.",
      "METHOD_SETTING_DETAIL_ERROR_LIST_BY_METHOD_SETTING": "The configuration details could not be listed by payment method.",
      "METHOD_SETTING_DETAIL_ERROR_DELETE": "The payment method configuration detail could not be deleted.",
      "METHOD_SETTING_DETAIL_ERROR_FIND_BY_METHOD_SETTING": "The configuration detail could not be found from the payment method.",
      //EndPaymentMethods
  
      //DynamicField
      "DYNAMIC_SELECT_ERROR_QUERY_CUSTOM": "Error executing custom query for dynamic field.",
      "ELECTRONIC_ERROR_VALIDATE_CUFE": "Error validating the CUFE of the electronic document.",
      //EndDynamicField
  
      //Accounting integration
      "ACCOUNTING_INTEGRATION_NOT_FOUND": "The requested accounting integration was not found.",
      //EndAccounting integration
  
      //SlotCount
      "LAST_SLOT_COUNT_NOT_FOUND": "The last slot count was not found.",
      "SLOT_NOT_FOUND": "The requested slot was not found.",
  
      //Vehicle
      "VEHICLE_ERROR_FIND_IDENTIFICATION": "The vehicle could not be found by its identification.",
      //End-Vehicle
  
      //VehicleTypes
      "VEHICLE_TYPES_PLATE_ERROR_QUERY": "Error querying the vehicle type by plate.",
      //endVehicleTypes
  
      //PlateRestriction
      "PLATE_RESTRICTION_ERROR_QUERY_LIST_BY_COMPANY": "The list of restrictions by company could not be retrieved.",
      "PLATE_RESTRICTION_ERROR_QUERY_LIST_BY_PLATE_RESTRICTION": "The list of restriction details by plate could not be retrieved.",
      "PLATE_RESTRICTION_NOT_FOUND": "The requested plate restriction was not found.",
      "PLATE_RESTRICTION_DETAIL_ERROR_DELETE": "The plate restriction detail could not be deleted.",
      "PLATE_RESTRICTION_ERROR_SAVE": "The plate restriction could not be saved.",
      "PLATE_RESTRICTION_DETAIL_ERROR_SAVE": "The plate restriction detail could not be saved.",
      "ERROR_PLATE_IS_REQUIRED": "The plate is required.",
      "ERROR_PLATE_RESTRICTION_FIND_BY_ID": "The plate restriction could not be found by ID.",
      "IS_HOLIDAY_OR_SPECIAL_DAY": "It is a holiday or special day.",
      "NOT_HAVE_RESTRICTION": "The plate has no restriction.",
      "NOT_IN_SCHEDULE": "The plate is not within the restricted schedule.",
      "PLATE_NOT_FOUND": "The plate was not found.",
      "PLATE_HAS_RESTRICTION": "The plate has an active restriction.",
      "ERROR_COMPANY_DOES_NOT_VALIDATE_PLATE_RESTRICTION": "The company does not validate plate restrictions.",
      //EndPlateRestriction
  
      //Calendar
      "ERROR_CALENDAR_FIND_BY_COMPANY_AND_DAY": "The calendar configuration for the specified company and day could not be found.",
      //End Calendar
  
      //Automation
      "ERROR_KACTUS_FILE_DOES_NOT_EXIST_OR_EMPTY": "The Kactus file does not exist or is empty.",
      "KACTUS_PROCESS_COMPLETED": "The Kactus process was successfully completed.",
      "CLOSURES_ATM_COMPLETED": "The automatic closures were successfully completed.",
  
      //Discount
      "EMPTY_BARCODE": "The barcode is empty.",
      "THE_INVOICE_HAS_ALREADY_BEEN_USED": "The invoice has already been used.",
      "INVALID_INVOICE_DATE": "The invoice date is not valid.",
      "QR_WITHOUT_IDENTIFICATION": "The QR code does not contain an identification.",
      "NO_MASKS_CONFIGURED": "No masks have been configured for the system.",
      "THE_QR_CODE_CANNOT_BE_PROCESSED": "The QR code cannot be processed.",
      "THE_INVOICE_DOES_NOT_CONTAIN_A_CUFE": "The invoice does not contain a CUFE.",
      "NOT_DISCOUNT_EXIST_FOR_INVOICE_RANGE": "No discounts exist for the indicated invoice range."
      //End-Discount
    }
  }